<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg
            :headerText="lbl.ultimateService.title.default"
            small
            :canGoBack="true"
        ></TopBarBg>
        <PageContent
            class="flex-auto"
            :hasPoweredBy="hasPoweredBy"
            rounded
            :marginTop="55"
            :paddingTop="0"
        >
            <TabNav
                v-model="categoryStates.current"
                :items="categoryStates.categoryList"
                :spaceNav="18"
                scrollable
                :fontBold="false"
                fontSize="text-sm"
                borderColorActive="border-primary"
                textColor="text-primary"
                textColorNoneActive="text-gray-secondary"
                paddingX="px-2"
                gap="mx-2"
                :itemText="itemTextKey"
                :itemValue="itemValueKey"
            ></TabNav>
            <div class="mx-18px my-6">
                <CampaignList
                    ref="campaignListComponent"
                    :modalController="modalController"
                ></CampaignList>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import { watch, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import ConfigManager from "@/config/ConfigManager";
// mixins
import ModalMixin from "@/mixin/ModalMixin";
import LocaleMixin from "@/mixin/LocaleMixin";
import ErrorApiMixin from "@/mixin/ErrorApiMixin";

// components
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
import Footer from "@/components/Layout/Footer/Footer.vue";
import TabNav from "@/components/Tab/TabNav.vue";
import ModalMaster from "@/components/Modal/ModalMaster.vue";
import CampaignList from "../../PlatinumService/component/CampaignList.vue";

// composable
import useCategoryComposable from "@/composables/Campaigns/CategoryComposable";
import useCampaignListComposable from "@/composables/Campaigns/CampaignListComposable";

export default {
    name: "UltimateServiceCampaignPage",
    props: {},
    components: {
        TopBarBg,
        PageContent,
        Footer,
        TabNav,
        ModalMaster,
        CampaignList,
    },
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    emits: [],
    data: function () {
        return {
            hasPoweredBy: false,
        };
    },
    computed: {
        itemTextKey: function () {
            if (this.localeCode == 1033) {
                return "nameEn";
            } else {
                return "nameTh";
            }
        },
        itemValueKey: function () {
            return "id";
        },
    },
    setup: function () {
        //#region  template refs
        const campaignListComponent = ref(null);
        //#endregion

        //#region use composable
        const route = useRoute();
        const router = useRouter();
        const { states: categoryStates, apiGetCategory } =
            useCategoryComposable(
                false,
                ConfigManager.getCategoryUltimateService(),
                true
            );

        // use campaign list composable should pass categoryStates to watch inside
        const { states: campaignListStates } = useCampaignListComposable(
            ConfigManager.getCampaignUltimateService()
        );
        campaignListStates.builder.setTop(25)
        //#endregion use composable

        //#region methods

        const setDefaultTab = () => {
            if (route.params.cat != null) {
                categoryStates.current = route.params.cat;
            } else {
                categoryStates.current =
                    categoryStates.categoryList?.[0].id ?? null;
            }
        };

        //#endregion

        onMounted(() => {

            //#region watch
            watch(
                () => categoryStates.categoryList,
                (val) => {
                    // console.log(val);
                    if (val.length > 0) {
                        setDefaultTab();
                    }
                }
            );

            // category change
            watch(
                () => categoryStates.current,
                (val) => {
                    if (val != null) {
                        router.replace({
                            params: {
                                cat: val,
                            },
                        });

                        campaignListStates.builder.setCatId(val);
                        campaignListStates.builder.setSkip(0) // reset skip

                        campaignListComponent.value.reinitList(
                            campaignListStates.builder.create(),
                            campaignListStates.filterBuilder.create()
                        );
                    }
                }
            );
            //#endregion

        });

        return {
            // component refs
            campaignListComponent,
            // states
            categoryStates,
            campaignListStates,
            // methods
            apiGetCategory,
        };
    },
    methods: {},
};
</script>
